// Disabled rule because this needs to be refactored
// Not worth the effort to fix dozen's of lint errors in this file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { DragEvent, useState, useEffect, Fragment } from 'react';
import UploadIcon from './icon_upload.svg';
import ErrorIcon from './x_icon.svg';
import { UseFormRegister } from 'react-hook-form';
import { AboutYouInput } from '../BusinessFormContainer/AboutYou';

export interface FileInputProps {
  onClick?: () => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  reset?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  register?: UseFormRegister<AboutYouInput>;
  name?: string;
  testId?: string;
  value?: File | string;
  keyNumber?: string;
  size?: string;
  // Disabled rule due current implementation
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  image?: any;
  disableUpload?: boolean;
}

export default function MiniFileInput(props: FileInputProps) {
  const [dragActive, setDragActive] = useState(false);
  const [fileSelected, setFileSelected] = useState(undefined);
  const [invalidInput, setInvalidInput] = useState(false);
  const [changedFromInvalidToValid, setChangedFromInvalidToValid] =
    useState(false);

  const validateImage = async (file: File) => {
    if (file instanceof File) {
      /*
      TODO: ALIGN ON IMAGE VALIDATION RULES -> https://spinspire.monday.com/boards/3397008425/pulses/4720025969

      const img = new Image();
      img.src = URL.createObjectURL(file); //use image API to access height & width
      await img.decode();
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      const validRectangleRatio =
        width / height >= 1.3 && width / height <= 1.7; // something close to 3:2 ratio
      const validSquareRatio = width / height >= 0.9 && width / height <= 1.1; // something close to square
      const validSevenToFiveRatio =
        width / height >= 1.4 && width / height <= 1.5; // something close to 7:5 ratio
      return (
        validSize &&
        (validRectangleRatio || validSquareRatio || validSevenToFiveRatio)
      );
      */

      const validSize = file.size >= 30000 && file.size <= 15000000; // current validation - 30k min, 15MB max
      return validSize;
    }
  };

  const handleInputFile = async (
    e: React.ChangeEvent<HTMLInputElement> | File | string
  ) => {
    if (fileSelected) {
      setFileSelected(undefined);
    }
    if (e.target?.files) {
      const [file] = e.target.files;
      const imageHasCorrectAttributes = await validateImage(file);
      if (!imageHasCorrectAttributes) {
        setFileSelected(false);
        if (changedFromInvalidToValid) {
          setChangedFromInvalidToValid(false);
        }
        setInvalidInput(true);
        props.reset(e);
      } else {
        if (invalidInput) {
          setChangedFromInvalidToValid(true);
          setInvalidInput(false);
        }
        setFileSelected(URL.createObjectURL(file));
        props.handleChange(e);
      }
    }
    if (e instanceof File) {
      //check if there is already an image for this input, set it
      setFileSelected(URL.createObjectURL(e));
      props.handleChange(e);
    }
    if (typeof e === 'string') {
      // if the input props are a string instead of a file(props come from DB instead of file input), set it
      setFileSelected(e);
    }
  };

  const handleDrag = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
    /*
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
    */
  };

  // Disabled rule due current implementation
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleDrop = (_e: DragEvent<HTMLDivElement>) => {
    /*
    e.preventDefault();
    e.stopPropagation();
    alert('file dropped');
    setDragActive(false);
    handleInputFile(e);
    */
    setDragActive(false);
  };

  useEffect(() => {
    if (props.value) {
      handleInputFile(props.value);
    }
  }, [props.value]);

  const inputComponent = props.register ? (
    <input
      {...props.register(props.name, {
        onChange: handleInputFile,
      })}
      disabled={!!props.disableUpload}
      id={`photo-upload ${props.keyNumber}`}
      type="file"
      accept=".jpg, .jpeg, .png"
    />
  ) : (
    <input
      name={props.name}
      disabled={!!props.disableUpload}
      id={`photo-upload ${props.keyNumber}`}
      type="file"
      onChange={handleInputFile}
      accept=".jpg, .jpeg, .png"
    />
  );

  return (
    <div
      data-testid={props.testId}
      className={`mini-file-uploader${dragActive ? ' dragged' : ''}${
        props.size ? props.size : ''
      }`}
      onDrop={handleDrop}
      onDragOver={handleDrag}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
    >
      <label
        className={`mini-input-label ${props.size} ${
          !!invalidInput && ' invalid-photo'
        } ${changedFromInvalidToValid ? ' sucessful-photo-validation' : ''}`}
        htmlFor={`photo-upload ${props.keyNumber}`}
      >
        {inputComponent}
        <img
          src={
            fileSelected ? fileSelected : invalidInput ? ErrorIcon : UploadIcon
          }
          className={
            fileSelected
              ? `mini-file-input-selected-image ${props.size}`
              : props.size !== 'mini-input-rectangle'
              ? 'mini-file-input-icon'
              : 'rectangle-mini-file-input-icon'
          }
          alt="upload a file"
        />
        {!fileSelected && (
          <span
            className={
              props.size !== 'mini-input-rectangle'
                ? 'mini-subtitle'
                : 'rectangle-mini-subtitle'
            }
          >
            {invalidInput ? (
              'Invalid image!'
            ) : !!props.disableUpload ? null : (
              <Fragment>
                <u>Upload image</u>
              </Fragment>
            )}
          </span>
        )}
      </label>
    </div>
  );
}
